/* lua.js generated code 0.3.0 */

function xexport(param, value) {
    let name = tostring(param)
    global[name] = cc[name] = value
}

let smallResReg = /@6x$/
// cc.exports.export = xexport
const smallResExtList = ['.csb', '.png', '.jpg', '.fnt', '.plist', '.pack', '.atlas']
function getRealResourceName(fileName) {
    var realResourcePath
    if (/^https?/.test(fileName)) {
        return fileName
    }
    if (__use_small_res) {
        //print(fileName)
        var prefix = cc.path.mainFileName(fileName, suffix)
        var suffix = cc.path.extname(fileName)
        // 在解析子node的时候，子node的文件已经包含@6x
        if (smallResExtList.indexOf(suffix) > -1 && !smallResReg.test(prefix)) {
            var postfix = _G.__use_res_postfix;
            if (postfix == null || postfix == "")
                postfix = "@6x";
            prefix = prefix + postfix
        }
        realResourcePath = prefix + suffix
    } else {
        realResourcePath = fileName
    }
    realResourcePath = realResourcePath.replace(/\.csb$/, '.json')
    return realResourcePath
}

// dealAliaseRes = function (resources) {
//     let realResList = {}
//     for (let key in resources) {
//         let realValue = getRealResourceName(resources[key], false)
//         let realKey = getRealResourceName(key, false)
//         realResList[realKey] = realValue
//     }
//     return realResList
// }

getRealResourceList = function (resources) {
    if (!(resources instanceof Array))
        resources = [resources]
    let listMap = {}
    
    let otherList = [] // for promise
    for (let i = 0; i < resources.length; i++) {
        let file = resources[i]
        if (typeof file === 'string') {
            let type = cc.path.extname(file)
            // plist/fnt自动加载同名png
            if (type === '.plist') {
                listMap[getRealResourceName(file.replace(/\.plist$/, '.png'))] = true
            } else if (type === '.fnt') {
                listMap[getRealResourceName(file.replace(/\.fnt$/, '.png'))] = true
            }
            listMap[getRealResourceName(file)] = true
        } else {
            otherList.push(file)
        }
    }
    return Object.keys(listMap).concat(otherList)
}

function xextends(obj, SuperClass) {
    setmetatableindex(obj, SuperClass)
    return obj
}
// var ClickableClass = table()
// ClickableClass.onClicked = function (callback) {
//     var self = this
//     self.enabled = true
//     var ctx = self
//     function onTouchesMoved(touch, event) { }
//     function onTouchesBegan(touch, event) {
//         if (!self.enabled) {
//             return false
//         }
//         var touchPos = touch.getLocation()
//         var scene = cc.Director.getInstance().getRunningScene()
//         var bound = he.HeDisplayUtil.getNodeGroupBounds(self, scene, -100)
//         var size = self.getBoundingBox()
//         var intersect = cc.rectContainsPoint(cc.rect(bound.x, bound.y, size.width, size.height), touchPos)
//         return intersect
//     }
//     function onTouchesEnd(touch, event) {
//         callback(touch)
//     }
//     var listener = cc.EventListenerTouchOneByOne.create()
//     listener.setSwallowTouches(true)
//     listener.registerScriptHandler(onTouchesBegan, cc.Handler.EVENT_TOUCH_BEGAN)
//     listener.registerScriptHandler(onTouchesMoved, cc.Handler.EVENT_TOUCH_MOVED)
//     listener.registerScriptHandler(onTouchesEnd, cc.Handler.EVENT_TOUCH_ENDED)
//     var eventDispatcher = self.getEventDispatcher()
//     eventDispatcher.addEventListenerWithSceneGraphPriority(listener, self)
//     return self
// }
// var ButtonClass = xClass("ButtonClass", ClickableClass)
// ButtonClass.prototype.setString = function (value) {
//     var self = this
//     var label = self.getChildByName("label")
//     if (label) {
//         label.setString(value)
//     }
// }
// function clickable(obj) {
//     xextends(obj, ClickableClass)
//     return obj
// }
function button(obj) {
    xextends(obj, ButtonClass)
    var hd = obj.getChildByName("labelSize")
    if (hd) {
        hd.removeFromParent(true)
    }
    return obj
}
// t1 Localhost:timeInSec() | os.time()
// t2 Localhost:timeInSec() | os.time()
function isSameDay(t1, t2) {
    if (t1 && t2 && type(t1) === "number" && type(t2) === "number") {
        var d1 = os.date("%Y-%m-%d", t1)
        var d2 = os.date("%Y-%m-%d", t2)
        return d1 === d2
    }
    return false
}
//--------------------------
//tiem  :second
//--------------------------
function convertTimeToFrames(time) {
    // body
    // WARN: maybe multi result
    return Math.ceil(time * GamePlayConfig_Action_FPS)
}
// TODO: restore
// xexport("isLocalDevelopMode", he.StartupConfig.getInstance().isLocalDevelopMode())
xexport("__use_small_res", false)
// xexport("bundleVersion", he.MetaInfo.getInstance().getApkVersion())
xexport("getRealResourceName", getRealResourceName)
xexport("extends", xextends)
// xexport("clickable", clickable)
xexport("button", button)
xexport("isSameDay", isSameDay)
// xexport("packageName", he.MetaInfo.getInstance().getPackageName())
xexport("convertTimeToFrames", convertTimeToFrames)